<template>
  <div>
    <top-part />
    <div class="my-content">
      <home-grid :menuList="getAllMenuAPPattr"></home-grid>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import topPart from "../../components/topPart";
import homeGrid from "./components/grid";
import interfaceAttr from "../../centralControl/utils/interfaceAttr";
export default {
  components: {
    topPart,
    homeGrid
  },
  data() {
    return {
      getAllMenuAPPattr: [], //请求接口成功返回的菜单数据
      interAttrs: ["getAllMenuAPP"], //需要请求的接口名称
       stusConfig: "", //获取配置
    };
  },
  watch: {},
  created() {
     this.stusConfig = this.centralControl.utils.getConfig(
      this.centralControl.config,
      ["allItem", "manageErea"]
    );
    this.init();
  },
  mounted() {},
  methods: {
    getAllMenuAPP(data) {
      this.handleList(data);
    },
     handleList(datas) {
      const loginInfo = localStorage.getItem("loginInfo");
      let currentLoginInfo = loginInfo ? JSON.parse(loginInfo).identity : {};
      for (let items of datas) {
        let that = this;
        var data = items.list;
        for (var a = 0; a < data.length; a++) {
          var item = data[a];
          if (that.stusConfig[item.menu_code]) {
            let flagStatus =
              that.stusConfig[item.menu_code].visible.indexOf(
                currentLoginInfo
              ) == -1;
            if (flagStatus) {
              data.splice(a, 1);
              a--;
            }
          }
        }
      }
      this.getAllMenuAPPattr = datas;
    },
    init() {
      this.centralControl.utils.eachIndexattr(
        this,
        this.interAttrs,
        interfaceAttr
      );
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../../assets/stylus/index.styl';
@import '../../assets/stylus/reset.css';
</style>